export default function shouldUseModalSideBar() {
  return document.body.offsetWidth < 856;
}
